export const TackePrimjeneResourcesDE: TackePrimjeneResourcesBSInterface = {
  dupplicateError:
    "Hinzufügen fehlgeschlagen, eingegebene Daten sind dupliziert",
  odabirKompanije: {
    title: "Evidenzpunkte",
    dropdownLabel: "Unternehmen auswählen:",
    dropdownPlaceholder: "Unternehmen auswählen",
    dropdownNoOptionsMessage: "Keine Unternehmen eingegeben",
    addCompanyButton: "Unternehmen hinzufügen",
    next: "Auswählen",
    back: "Zurück",
    errorLoading:
      "Fehler beim Laden. Bitte kontaktieren Sie den Administrator.",
  },
  odabirPoslovnice: {
    title: "Evidenzpunkte",
    dropdownLabel: "Filiale auswählen:",
    dropdownPlaceholder: "Filiale auswählen",
    dropdownNoOptionsMessage: "Keine Filialen eingegeben",
    addCompanyButton: "Filiale hinzufügen",
    next: "Bearbeiten",
    back: "Zurück",
    errorLoading:
      "Fehler beim Laden. Bitte kontaktieren Sie den Administrator.",
  },
  izmjenaTP: {
    title: "AP bearbeiten",
    recordpointtreesError: "Record Point JSON eingeben",
    recordpointtreesLabel: "Evidenzpunkte eingeben",
    loadTemplateButton: "Beispiel hinzufügen",
    recordpointtreesName: "recordpointtrees",
    successModal: {
      title: "Dateneingabe",
      body: "Das Hinzufügen von Daten wurde erfolgreich abgeschlossen. Wählen Sie OK zum Fortfahren.",
      buttonOk: "OK",
    },
    buttonTP: "Evidenzpunkte hinzufügen",
    errorLoading:
      "Fehler beim Laden. Bitte kontaktieren Sie den Administrator.",
    errorUpdate:
      "Fehler beim Update. Bitte kontaktieren Sie den Administrator.",
  },
};

export interface TackePrimjeneResourcesBSInterface {
  dupplicateError: string;
  odabirKompanije: {
    title: string;
    dropdownLabel: string;
    dropdownPlaceholder: string;
    dropdownNoOptionsMessage: string;
    addCompanyButton: string;
    next: string;
    back: string;
    errorLoading: string;
  };
  odabirPoslovnice: {
    title: string;
    dropdownLabel: string;
    dropdownPlaceholder: string;
    dropdownNoOptionsMessage: string;
    addCompanyButton: string;
    next: string;
    back: string;
    errorLoading: string;
  };
  izmjenaTP: {
    title: string;
    recordpointtreesError: string;
    recordpointtreesLabel: string;
    loadTemplateButton: string;
    recordpointtreesName: string;
    successModal: {
      title: string;
      body: string;
      buttonOk: string;
    };
    buttonTP: string;
    errorLoading: string;
    errorUpdate: string;
  };
}

/*
Example json array: 
{
  "TackePrimjene": [
    {
      "NazivTacke": "Dvoriste",
      "Parent": "",
      "Order": "1"
    },
    {
      "NazivTacke": "Objekat",
      "Parent": "",
      "Order": "2"
    },
    {
      "NazivTacke": "Kancelarija",
      "Parent": "Objekat",
      "Order": "1"
    },
    {
      "NazivTacke": "WC",
      "Parent": "Objekat",
      "Order": "1"
    },
    {
      "NazivTacke": "Lavabo",
      "Parent": "WC",
      "Order": "1"
    },
    {
      "NazivTacke": "Cesma",
      "Parent": "Lavabo",
      "Order": "1"
    },
    {
      "NazivTacke": "Ogledalo",
      "Parent": "Lavabo",
      "Order": "2"
    }
  ]
}

*/
